import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { Navigate, Outlet } from "react-router";
import { useCheckUser } from "@/api/user/check-user";
import useOnboardingData from "@/store/onboarding-data";
import useGlobalLoading from "@/store/global-loading";
import FullscreenLoading from "../fullscreen-loading";

const OnboardingRest = () => {
    const { isAuthenticated, isLoading } = useKindeAuth();
    const { isLoading: checkUserLoading } = useCheckUser();

    const { setIsLoading } = useGlobalLoading();
    const { isStep1Complete, isStep2Complete, isStep3Complete, isInitialized, userData } = useOnboardingData();

    // Show loading screen if authentication or user check is in progress
    if (isLoading || checkUserLoading) setIsLoading(true);

    // Redirect to login if not authenticated
    if (!isAuthenticated) return <Navigate to="/auth/sign-in" />;

    // Handle onboarding flow
    if (!isStep1Complete && userData?.role !== "member") return <Navigate to="/onboarding/step-1" />;
    if (!isStep2Complete && userData?.role !== "member") return <Navigate to="/onboarding/step-2" />;
    if (!isStep3Complete && userData?.role !== "member") return <Navigate to="/onboarding/step-3" />;
    if (!isInitialized && userData?.role !== "member") return <Navigate to="/app/dashboard?user_initialized=false" />;
    if (isInitialized) return <Navigate to="/app/dashboard" />;
    if (userData?.role !== "member") return <Navigate to="/app/dashboard" />;

    // Render the protected route content
    return (
        <>
            <Outlet />;
            <FullscreenLoading />
        </>
    );
};

export default OnboardingRest;
